import axios, { AxiosRequestConfig, AxiosError } from "axios";
import { backendUrl } from "@/config";

const axiosInstance = axios.create({
  baseURL: backendUrl,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const identity = JSON.parse(localStorage.getItem("identity") || "null");
    if (identity) {
      config.headers["Authorization"] = `Bearer ${identity.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized. Logging out...");
      localStorage.removeItem("identity");
      window.location.reload();
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;

// Orval-compatible mutator function using your axiosInstance
export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const source = axios.CancelToken.source();
  const promise = axiosInstance({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }) => data);

  // @ts-expect-error - attaching cancel function to promise for CancelToken compatibility
  promise.cancel = () => {
    source.cancel("Query was cancelled");
  };

  return promise;
};

// Optional: error and body type helpers for Orval
export type ErrorType<Error> = AxiosError<Error>;
export type BodyType<BodyData> = BodyData;
